import React from 'react'

const Sponsorship = () => {
  return (
    <div>Sponsorship</div>
  )
}

export default Sponsorship